import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Cliente/addCliente`, method: 'POST', body: values, token: token})
}